export default "__VITE_ASSET__ByXTkDOP__"